import { connect } from 'react-redux';

import {NavigationTabsContainerFunctions} from 'Component/NavigationTabs/NavigationTabs.type';
import {
    DEFAULT_NAVIGATION_TABS_STATE as SOURCE_DEFAULT_NAVIGATION_TABS_STATE,
    mapDispatchToProps,
    mapStateToProps,
    NavigationTabsContainer as SourceNavigationTabsContainer,
} from 'SourceComponent/NavigationTabs/NavigationTabs.container';
import {NavigationState} from 'Store/Navigation/Navigation.type';
import {isSignedIn} from 'Util/Auth/IsSignedIn';
import browserHistory from 'Util/History';
import {appendWithStoreCode} from 'Util/Url';

import {NavigationTabsMap} from './NavigationTabs.config';

export {
    mapStateToProps,
    mapDispatchToProps,
};

export const DEFAULT_NAVIGATION_TABS_STATE = SOURCE_DEFAULT_NAVIGATION_TABS_STATE;

/** @namespace Steinkrueger/Component/NavigationTabs/Container */
export class NavigationTabsContainer extends SourceNavigationTabsContainer {
    routeMap: Record<string, NavigationState> = {
        '/customer/account': { name: NavigationTabsMap.ACCOUNT_TAB },
        '/sales/order/history': { name: NavigationTabsMap.ACCOUNT_TAB },
        '/downloadable/customer/products': { name: NavigationTabsMap.ACCOUNT_TAB },
        '/customer/address': { name: NavigationTabsMap.ACCOUNT_TAB },
        '/newsletter/manage': { name: NavigationTabsMap.ACCOUNT_TAB },
        '/sales/order/view': { name: NavigationTabsMap.ACCOUNT_TAB },
        '/wishlist': { name: NavigationTabsMap.WISHLIST_TAB },
        '/checkout': { name: NavigationTabsMap.CHECKOUT_TAB },
        '/cart': { name: NavigationTabsMap.CART_TAB },
        '/': { name: NavigationTabsMap.HOME_TAB },
        '': { name: NavigationTabsMap.HOME_TAB },
    };

    containerFunctions: NavigationTabsContainerFunctions = {
        onMenuButtonClick: this.onMenuButtonClick.bind(this),
        onMyAccountButtonClick: this.onMyAccountButtonClick.bind(this),
        onMinicartButtonClick: this.onMinicartButtonClick.bind(this),
        onHomeButtonClick: this.onHomeButtonClick.bind(this),
        onWishlistButtonClick: this.onWishlistButtonClick.bind(this),
    };

    onWishlistButtonClick(): void {
        const { pathname } = location;
        const url = appendWithStoreCode(isSignedIn() ? '/wishlists' : '/');

        if (pathname !== url) {
            browserHistory.push(url);
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationTabsContainer);
